import React, { Component } from 'react';
import Header from '../../components/user/common/Header';
import PageTitle from '../../components/user/common/PageTitle';
import Footer from '../../components/common/Footer';
import axios from 'axios';
import { setLoading } from './../../store/reducers/global-reducer';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import Select from 'react-select';
import { toast } from 'react-toastify';
import SpinnerLoader from './../../components/common/SpinnerLoader';
import store from '../../store/index';
import userImg from '../../assets/images/user.png'
import * as Yup from 'yup';
import emptyImg from '../../assets/images/emptyimage.png'
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal } from 'react-bootstrap';
import UploadMyprofile from './UploadMyprofile';
import { Helmet } from 'react-helmet';
import arrow_back from '../../assets/icons/arrow-back.svg'
import ChangePasswordSection from '../../components/common/ChangePasswordSection';
import '../../assets/css/buyer-my-profile.css';

const selectFieldStyles = {
    control: (provided) => ({
        ...provided,
        minHeight: 38,
        borderRadius: 4,
        borderColor: '#ced4da',
        boxShadow: 'none',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};

class MyProfile extends Component {
    constructor(props) {
        super(props);
        this.authInfo = JSON.parse(localStorage.getItem('authInfo'));
        this.cloudName = process.env.REACT_APP_CLOUD_NAME;
        this.apiKey = process.env.REACT_APP_CLOUD_API_KEY;
        this.apiSecret = process.env.REACT_APP_CLOUD_API_SECRET;
        this.fileInputRef = React.createRef();
        var editProfile;

        if (localStorage.getItem('editProfile') !== null) {
            if (localStorage.getItem('editProfile') === 'false') {
                editProfile = false;
            } else {
                editProfile = true;
            }
        } else {
            editProfile = true;
        }

        this.state = {
            emptyImg: emptyImg,
            userDetails: [],
            accountTypeOptions: [
                { label: 'Buyer', value: 'user' },
            ],
            purchaseTypeOptions: [
                { label: 'Retailer', value: 'retail' },
                { label: 'Wholesale', value: 'wholesale' }
            ],
            selectedAccountType: { label: 'Buyer', value: 'user' },
            selectedPurchaseType: { label: 'Retailer', value: 'retail' },
            editProfile: editProfile,
            showModal: false,
            showImageModal: false,
            imageToView: '',
            countryOptions: [],
            stateOptions: [],
            cityOptions: [],
        };
        this.imageRef = null;

        if (localStorage.getItem('editProfile') === null) {
            localStorage.setItem('editProfile', false);
        }
        toast.configure();
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(setLoading({ loading: true }));
        this.loadCountryOptions();
        axios.get('user/my-profile/' + this.authInfo.id, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Bearer ${this.authInfo.token}`
            }
        }).then((response) => {
            if (response.data.status) {
                let resData = response.data.data;
                let selectedAccountType = '';
                let selectedPurchaseType = '';

                if (resData.role === 'user') {
                    selectedAccountType = { label: 'Buyer', value: 'user' };
                } else {
                    selectedAccountType = { label: 'Seller', value: 'seller' };
                }

                if (resData.purchase_type === 'retail') {
                    selectedPurchaseType = { label: 'Retailer', value: 'retail' };
                } else {
                    selectedPurchaseType = { label: 'Wholesale', value: 'wholesale' };
                }

                this.setState({
                    userDetails: resData,
                    selectedAccountType,
                    selectedPurchaseType
                }, () => {
                    const countryCode = resData?.address?.country;
                    const stateName = resData?.address?.state;
                    if (countryCode) {
                        this.loadStateOptions(countryCode, stateName, resData?.address?.city);
                    }
                });
            }
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            setTimeout(() => {
                dispatch(setLoading({ loading: false }));
            }, 300);
        });
    }

    handleChangeAccount = selectedOption => this.setState({ selectedAccountType: selectedOption });
    handlePurchaseType = selectedOption => this.setState({ selectedPurchaseType: selectedOption });

    loadCountryOptions = () => {
        axios.get('seller/countries')
            .then((response) => {
                if (response.data.status && Array.isArray(response.data.data)) {
                    const countryOptions = response.data.data.map((row) => ({
                        label: row.country,
                        value: row.code,
                    }));
                    this.setState({ countryOptions });
                }
            })
            .catch((error) => {
                console.error('Failed to load countries:', error);
            });
    };

    resolveCountryOption = (stored, options) => {
        if (!stored || !options?.length) return null;
        const raw = String(stored).trim();
        const upper = raw.toUpperCase();
        return (
            options.find((o) => o.value === upper) ||
            options.find((o) => o.label.toUpperCase() === upper) ||
            null
        );
    };

    resolveLocationOption = (stored, options) => {
        if (!stored) return null;
        const raw = String(stored).trim();
        if (!raw) return null;
        return (
            options.find((o) => o.value === raw) ||
            options.find((o) => o.label.toLowerCase() === raw.toLowerCase()) ||
            { label: raw, value: raw }
        );
    };

    loadStateOptions = (countryCode, preserveState, preserveCity) => {
        if (!countryCode) {
            this.setState({ stateOptions: [], cityOptions: [] });
            return Promise.resolve();
        }

        return axios.post('seller/states', { country_code: countryCode })
            .then((response) => {
                if (response.data.status && Array.isArray(response.data.data)) {
                    const stateOptions = response.data.data.map((value) => ({
                        label: value,
                        value,
                    }));
                    this.setState({ stateOptions }, () => {
                        if (preserveState) {
                            this.loadCityOptions(countryCode, preserveState, preserveCity);
                        } else {
                            this.setState({ cityOptions: [] });
                        }
                    });
                } else {
                    this.setState({ stateOptions: [], cityOptions: [] });
                }
            })
            .catch((error) => {
                console.error('Failed to load states:', error);
                this.setState({ stateOptions: [], cityOptions: [] });
            });
    };

    loadCityOptions = (countryCode, stateName, preserveCity) => {
        if (!countryCode || !stateName) {
            this.setState({ cityOptions: [] });
            return Promise.resolve();
        }

        return axios.post('seller/cities', { country_code: countryCode, state: stateName })
            .then((response) => {
                if (response.data.status && Array.isArray(response.data.data)) {
                    const cityOptions = response.data.data.map((value) => ({
                        label: value,
                        value,
                    }));
                    const storedCity = preserveCity ? String(preserveCity).trim() : '';
                    if (
                        storedCity &&
                        !cityOptions.some((option) => option.value.toLowerCase() === storedCity.toLowerCase())
                    ) {
                        cityOptions.unshift({ label: storedCity, value: storedCity });
                    }
                    this.setState({ cityOptions });
                } else {
                    const storedCity = preserveCity ? String(preserveCity).trim() : '';
                    this.setState({
                        cityOptions: storedCity ? [{ label: storedCity, value: storedCity }] : [],
                    });
                }
            })
            .catch((error) => {
                console.error('Failed to load cities:', error);
                const storedCity = preserveCity ? String(preserveCity).trim() : '';
                this.setState({
                    cityOptions: storedCity ? [{ label: storedCity, value: storedCity }] : [],
                });
            });
    };

    handleCountryChange = (option, setFieldValue) => {
        const countryCode = option ? option.value : '';
        setFieldValue('address.country', countryCode);
        setFieldValue('address.state', '');
        setFieldValue('address.city', '');
        this.loadStateOptions(countryCode);
    };

    handleStateChange = (option, setFieldValue, countryCode) => {
        const stateName = option ? option.value : '';
        setFieldValue('address.state', stateName);
        setFieldValue('address.city', '');
        this.loadCityOptions(countryCode, stateName);
    };

    handleSubmit = (values) => {
        const { dispatch } = this.props;
        dispatch(setLoading({ loading: true }));

        axios.put(`user/edit-profile/${this.authInfo.id}`, values, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                "Authorization": `Bearer ${this.authInfo.token}`
            }
        }).then((response) => {
            if (response.data.status) {
                console.log("response", response);
                toast.success(response.data.message, { autoClose: 3000 });
                this.handleEdit();
            }
        }).catch(error => {
            toast.dismiss();
            if (error.response && error.response.data.status === false) {
                toast.error(error.response.data.message, { autoClose: 3000 });
                console.log("My profile error message: ", error.response)
            }
        }).finally(() => {
            setTimeout(() => {
                dispatch(setLoading({ loading: false }));
            }, 300);
        });
    }


    handleEdit = () => {
        this.setState({ userDetails: this.state.userDetails })
        let editProfile = localStorage.getItem('editProfile');
        if (editProfile !== null && editProfile === 'false') {
            localStorage.setItem('editProfile', true);
            this.setState({ editProfile: true });
        } else {
            localStorage.setItem('editProfile', false);
            this.setState({ editProfile: false });
        }
    }

    // Function to toggle modal visibility
    handleModalToggle = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
        }));
    };


    handleImageModalToggle = (original_image_url) => {
        this.setState(prevState => ({
            showImageModal: !prevState.showImageModal,
            imageToView: original_image_url || prevState.imageToView
        }));
    };


    // Method to update the user's profile image URL and image_id
    updateProfileImage = (original_image_url, original_image_id, image_url, image_id) => {
        this.setState(prevState => ({
            userDetails: {
                ...prevState.userDetails,
                original_image_url: original_image_url,
                original_image_id: original_image_id,
                image_url: image_url,
                image_id: image_id,
            }
        }));
    };


    render() {
        const { loading } = store.getState().global;
        const { editProfile, userDetails, showImageModal, imageToView } = this.state;
        const profileImageUrl = userDetails.image_url || userImg;

        return (
            <React.Fragment>
                {loading === true ? <SpinnerLoader /> : ''}
                <Header />
                <PageTitle title="My Profile" />
                <section className="inr_wrap">
                    <Helmet><title>{"Profile - Pay Earth"}</title></Helmet>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="comm_profile">
                                    <div className="post_by">
                                        <div className="poster_img" style={{ cursor: "pointer", border: "5px solid #fbf500", borderRadius: "80px",  }} onClick={() => this.handleImageModalToggle(profileImageUrl)}>
                                            <img src={profileImageUrl} alt="Profile" />
                                        </div>
                                        <input
                                            type="file"
                                            ref={this.fileInputRef}
                                            style={{ display: 'none' }}
                                            onChange={this.uploadProfileOnClodinary}
                                        />
                                        <div className="poster_info">
                                            <div className="poster_name">{this.state.userDetails.name}</div>
                                            <button className="btn btn-primary" onClick={this.handleModalToggle}>
                                                <i className="bi bi-pencil"></i>
                                            </button>
                                            <button className="btn btn-success" onClick={() => this.handleImageModalToggle(userDetails.original_image_url)}>
                                                <i className="bi bi-eye"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <ul>
                                        <li>
                                            <div className="fp_fc">{this.state.userDetails?.community?.followerData.length || 0}</div>
                                            <small>Followers</small>
                                        </li>
                                        <li>
                                            <div className="fp_fc">{this.state.userDetails?.community?.followingData.length || 0}</div>
                                            <small>Following</small>
                                        </li>
                                        <li>
                                            <div className="fp_fc">{this.state.userDetails?.community?.blockedUsers.length || 0}</div>
                                            <small>Blocked</small>
                                        </li>
                                    </ul>
                                    <div className=''>
                                        <button
                                            type="button"
                                            className="btn custum_back_btn btn_yellow mx-auto"
                                            onClick={() => window.history.back()}
                                        >
                                            <img src={arrow_back} alt="back" />&nbsp;
                                            Back
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="cart">
                                    <div className="cart_wrap">
                                        <div className="items_incart d-flex justify-content-between align-items-center">
                                            <span className="text-uppercase">
                                                Personal Information
                                            </span>
                                            {/* <button
                                                type="button"
                                                className="btn custom_btn btn_yellow"
                                                onClick={() => window.history.back()}
                                            >
                                                Back
                                            </button> */}
                                        </div>
                                    </div>
                                    <div className="profile_edit_wrap">
                                        <div className="row">
                                            <div className="col-md-12 mb-5">
                                                <Formik
                                                    initialValues={{
                                                        name: this.state.userDetails.name,
                                                        email: this.state.userDetails.email,
                                                        role: this.state.selectedAccountType.value,
                                                        purchase_type: this.state.selectedPurchaseType.value,
                                                        phone: this.state.userDetails.phone || '',
                                                        address: {
                                                            street: this.state.userDetails?.address?.street || '',
                                                            city: this.state.userDetails?.address?.city || '',
                                                            state: this.state.userDetails?.address?.state || '',
                                                            country: this.state.userDetails?.address?.country || '',
                                                            zip: this.state.userDetails?.address?.zip || '',
                                                        }
                                                    }}
                                                    validationSchema={Yup.object().shape({
                                                        name: Yup.string().required("Name is required.").min(3, 'Name is too short - should be 3 chars minimum.').max(50, 'Name is too long - should be 50 chars maximum.'),
                                                        email: Yup.string().email().required("Email is required."),
                                                        phone: Yup.string().matches(/^[0-9]+$/, "Phone number is not valid").min(10, 'Phone number is too short').max(15, 'Phone number is too long').required("Phone is required."),
                                                        address: Yup.object().shape({
                                                            street: Yup.string().required("Street is required."),
                                                            city: Yup.string().required("City is required."),
                                                            state: Yup.string().required("State is required."),
                                                            country: Yup.string().required("Country is required."),
                                                            zip: Yup.number().required("Zip code is required.").positive().integer(),
                                                        })
                                                    })}
                                                    onSubmit={(values, { setSubmitting }) => {
                                                        this.handleSubmit(values);
                                                        setTimeout(() => {
                                                            setSubmitting(false);
                                                        }, 400);
                                                    }}
                                                    enableReinitialize={true}
                                                >
                                                    {({
                                                        values,
                                                        errors,
                                                        touched,
                                                        handleChange,
                                                        handleBlur,
                                                        handleSubmit,
                                                        isSubmitting,
                                                        setFieldValue,
                                                        setFieldTouched,
                                                    }) => {
                                                        const selectedCountry = this.resolveCountryOption(
                                                            values.address.country,
                                                            this.state.countryOptions
                                                        );
                                                        const selectedState = this.resolveLocationOption(
                                                            values.address.state,
                                                            this.state.stateOptions
                                                        );
                                                        const selectedCity = this.resolveLocationOption(
                                                            values.address.city,
                                                            this.state.cityOptions
                                                        );
                                                        const hasCountry = Boolean(values.address.country);
                                                        const hasState = Boolean(values.address.state);
                                                        return (
                                                        <form className="in_form buyer-my-profile-form px-3 ps-md-0" onSubmit={handleSubmit}>
                                                            <div className="form-row row buyer-profile-form-columns">
                                                                <div className="col-md-6 buyer-profile-personal-stack">
                                                                    <div className="form-group">
                                                                        <label htmlFor="name">Name <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="name"
                                                                            name="name"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.name}
                                                                            disabled={!editProfile}
                                                                        />
                                                                        {touched.name && errors.name && (
                                                                            <small className="text-danger">{errors.name}</small>
                                                                        )}
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="email">Email <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="email"
                                                                            className="form-control"
                                                                            id="email"
                                                                            name="email"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.email}
                                                                            disabled={!editProfile}
                                                                            maxLength="50"
                                                                        />
                                                                        {touched.email && errors.email && (
                                                                            <small className="text-danger">{errors.email}</small>
                                                                        )}
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="phone">Phone <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="phone"
                                                                            name="phone"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.phone}
                                                                            disabled={!editProfile}
                                                                        />
                                                                        {touched.phone && errors.phone && (
                                                                            <small className="text-danger">{errors.phone}</small>
                                                                        )}
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="account-type">Account Type <span className="text-danger">*</span></label>
                                                                        <Select
                                                                            inputId="account-type"
                                                                            className="buyer-profile-select border-0 p-0"
                                                                            options={this.state.accountTypeOptions}
                                                                            value={this.state.selectedAccountType}
                                                                            onChange={this.handleChangeAccount}
                                                                            isDisabled={!editProfile}
                                                                            styles={selectFieldStyles}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 buyer-profile-location-stack">
                                                                    <div className="form-group">
                                                                        <label htmlFor="country">
                                                                            Country <span className="text-danger">*</span>
                                                                            <span
                                                                                className="buyer-profile-field-hint text-muted"
                                                                                title="Used for tax at checkout. The selected ISO country code is saved to your profile."
                                                                                aria-label="Used for tax at checkout. The selected ISO country code is saved to your profile."
                                                                            >
                                                                                <i className="bi bi-info-circle" aria-hidden="true" />
                                                                            </span>
                                                                        </label>
                                                                        <Select
                                                                            inputId="country"
                                                                            className="buyer-profile-select border-0 p-0"
                                                                            options={this.state.countryOptions}
                                                                            value={selectedCountry}
                                                                            onChange={(option) => {
                                                                                this.handleCountryChange(option, setFieldValue);
                                                                            }}
                                                                            onBlur={() => setFieldTouched('address.country', true)}
                                                                            isDisabled={!editProfile}
                                                                            placeholder="Select country"
                                                                            styles={selectFieldStyles}
                                                                        />
                                                                        {touched.address?.country && errors.address?.country && (
                                                                            <small className="text-danger">{errors.address.country}</small>
                                                                        )}
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="state">State <span className="text-danger">*</span></label>
                                                                        <Select
                                                                            inputId="state"
                                                                            className="buyer-profile-select border-0 p-0"
                                                                            options={this.state.stateOptions}
                                                                            value={selectedState}
                                                                            onChange={(option) => {
                                                                                this.handleStateChange(option, setFieldValue, values.address.country);
                                                                            }}
                                                                            onBlur={() => setFieldTouched('address.state', true)}
                                                                            isDisabled={!editProfile || !hasCountry}
                                                                            placeholder={hasCountry ? 'Select state' : 'Select country first'}
                                                                            styles={selectFieldStyles}
                                                                            noOptionsMessage={() => 'No states available for this country'}
                                                                        />
                                                                        {touched.address?.state && errors.address?.state && (
                                                                            <small className="text-danger">{errors.address.state}</small>
                                                                        )}
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="city">City <span className="text-danger">*</span></label>
                                                                        <Select
                                                                            inputId="city"
                                                                            className="buyer-profile-select border-0 p-0"
                                                                            options={this.state.cityOptions}
                                                                            value={selectedCity}
                                                                            onChange={(option) => {
                                                                                setFieldValue('address.city', option ? option.value : '');
                                                                            }}
                                                                            onBlur={() => setFieldTouched('address.city', true)}
                                                                            isDisabled={!editProfile || !hasState}
                                                                            placeholder={hasState ? 'Select city' : 'Select state first'}
                                                                            styles={selectFieldStyles}
                                                                            noOptionsMessage={() => 'No cities available for this state'}
                                                                        />
                                                                        {touched.address?.city && errors.address?.city && (
                                                                            <small className="text-danger">{errors.address.city}</small>
                                                                        )}
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="zip">Zip Code <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            id="zip"
                                                                            name="address.zip"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.address.zip}
                                                                            disabled={!editProfile}
                                                                        />
                                                                        {touched.address?.zip && errors.address?.zip && (
                                                                            <small className="text-danger">{errors.address.zip}</small>
                                                                        )}
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="street">Street <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="street"
                                                                            name="address.street"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.address.street}
                                                                            disabled={!editProfile}
                                                                        />
                                                                        {touched.address?.street && errors.address?.street && (
                                                                            <small className="text-danger">{errors.address.street}</small>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="form-group">
                                                                <label htmlFor="" className="invisible">btn</label>
                                                                {editProfile ? (
                                                                    <div>
                                                                        <button type="submit" className="btn custom_btn btn_yellow_bordered">Save</button>
                                                                        <button type="button" className="btn custom_btn btn_yellow_bordered ms-2" onClick={this.handleEdit}>Cancel</button>
                                                                    </div>
                                                                ) : (
                                                                    <button type="button" className="btn custom_btn btn_yellow_bordered" onClick={this.handleEdit}>Edit Profile</button>
                                                                )}
                                                            </div>
                                                        </form>
                                                        );
                                                    }}
                                                </Formik>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mt-4">
                                <div className="cart">
                                    <ChangePasswordSection
                                        apiPrefix="user"
                                        userId={this.authInfo.id}
                                        token={this.authInfo.token}
                                        hasPassword={this.state.userDetails?.hasPassword !== false}
                                        authProviders={this.state.userDetails?.authProviders || []}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />

                <Modal show={this.state.showModal} onHide={this.handleModalToggle} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Upload Profile</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <UploadMyprofile image_id={this.state.userDetails.image_id} original_image_id={this.state.userDetails.original_image_id} onProfileUpdate={this.updateProfileImage} onSaveComplete={this.handleModalToggle} />
                    </Modal.Body>
                </Modal>

                {/* Modal for viewing profile image */}
                <Modal show={showImageModal} onHide={() => this.handleImageModalToggle('')} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Profile Image</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='text-center'>
                            <img src={imageToView} alt="Profile" className="img-fluid" />
                        </div>

                    </Modal.Body>
                </Modal>

            </React.Fragment >
        );
    }
}

export default connect(setLoading)(MyProfile);
